import angular from 'angular';
import apiClientDataServiceFactory from '../Components/ApiClients/apiClientDataService.factory';

export default angular
    .module('app.integrations.factories', [])
    .factory('apiClientDataService', apiClientDataServiceFactory)
    .name;